import { gql } from '@apollo/client';

export const CREATE_SCHOOL_ENROLMENT_DATAS = gql`
  mutation createSchoolEnrolmentDatas($inputs: [CreateSchoolEnrolmentDataInput!]!) {
    enrolments: createSchoolEnrolmentDatas(inputs: $inputs) {
      id
    }
  }
`;
